import React from "react";
import {Redirect} from "react-router-dom";

const App: React.FC = (props: any) => <Redirect to={'/account'}/>;

export default App